module.exports = __webpack_public_path__ + "img/page2.c6110041.png";